import { render } from "./garmentCompositions.vue?vue&type=template&id=0132b974&ts=true"
import script from "./garmentCompositions.vue?vue&type=script&lang=ts"
export * from "./garmentCompositions.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__